import React from "react";
import "./Showcase.scss";
import { H3, L, SLable, SLableIcon } from "../../ui/Typography";
import { Textbox } from "../../ui";
import { Info } from "../../ui/icons";

function ShowcaseLabelNSupportingText() {
  return (
    <>
      <div className="showcase-wrapper">
        <H3>Label & Supporting text </H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>
                  (S) Label - 12px <br />
                  S. Text - 12px
                </th>
                <th>
                  (M) Label - 16px <br />
                  S. Text - 12px
                </th>
                <th>
                  (L) Label - 16px <br />
                  S. Text - 14px
                </th>
                <th>
                  (XL) Label - 20px <br />
                  S. Text - 16px
                </th>
              </tr>
              <tr>
                <th>Support text without icon</th>
                <td>
                  <L forInput="test1" size="sm">
                    First name
                  </L>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="sm"
                    widthSize="sm"
                    id="test1"
                  />
                  <SLable size="sm">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                  </SLable>
                </td>
                <td>
                  <L forInput="test2" size="md">
                    First name
                  </L>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="md"
                    widthSize="sm"
                    id="test2"
                  />
                  <SLable size="md">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor
                  </SLable>
                </td>
                <td>
                  <L forInput="test3" size="lg">
                    First name
                  </L>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="lg"
                    widthSize="sm"
                    id="test3"
                  />
                  <SLable size="lg">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor Lorem ipsum dolor sit amet, consectetur
                  </SLable>
                </td>
                <td>
                  <L forInput="test4" size="xl">
                    First name
                  </L>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="xl"
                    widthSize="sm"
                    id="test4"
                  />
                  <SLable size="xl">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor Lorem ipsum dolor sit amet, consectetur
                  </SLable>
                </td>
              </tr>
              <tr>
                <th>Support text with icon</th>
                <td>
                  <L forInput="test5" size="sm">
                    First name
                  </L>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="sm"
                    widthSize="sm"
                    id="test5"
                  />
                  <SLableIcon size="sm" icon={Info}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                  </SLableIcon>
                </td>
                <td>
                  <L forInput="test6" size="md">
                    First name
                  </L>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="md"
                    widthSize="sm"
                    id="test6"
                  />
                  <SLableIcon size="md" icon={Info}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor
                  </SLableIcon>
                </td>
                <td>
                  <L forInput="test7" size="lg">
                    First name
                  </L>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="lg"
                    widthSize="sm"
                    id="test7"
                  />
                  <SLableIcon size="lg" icon={Info}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor Lorem ipsum dolor sit
                  </SLableIcon>
                </td>
                <td>
                  <L forInput="test8" size="xl">
                    First name
                  </L>
                  <Textbox
                    type="text"
                    placeholder="Select Item"
                    size="xl"
                    widthSize="sm"
                    id="test8"
                  />
                  <SLableIcon size="xl" icon={Info}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor Lorem ipsum dolor sit amet, consectetur
                  </SLableIcon>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default ShowcaseLabelNSupportingText;
